const r = (r, s) => {
    customElements.get(r) || customElements.define(r, s);
  },
  s = () => `ids-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`,
  e = (r, s, e) => {
    e && r?.setAttribute(s, e);
  },
  t = (r, s, e) => {
    e && r.classList?.add(s);
  },
  n = (r, s) => {
    console.warn("IDS - Warning - ", r, s);
  },
  u = (r, s) => {
    console.error("IDS - Error - ", r, s);
  },
  i = r => r > 0 ? r < 10 ? "0" + r : "" + r : "",
  a = (r, s) => {
    switch (r) {
      case 0:
        return "Januari".substring(0, s);
      case 1:
        return "Februari".substring(0, s);
      case 2:
        return "Mars".substring(0, s);
      case 3:
        return "April".substring(0, s);
      case 4:
        return "Maj".substring(0, s);
      case 5:
        return "Juni".substring(0, s);
      case 6:
        return "Juli".substring(0, s);
      case 7:
        return "Augusti".substring(0, s);
      case 8:
        return "September".substring(0, s);
      case 9:
        return "Oktober".substring(0, s);
      case 10:
        return "November".substring(0, s);
      case 11:
        return "December".substring(0, s);
      default:
        return "";
    }
  };
export { s as generateId, i as getDayAsText, a as getMonthAsText, u as logError, n as logWarning, r as registerComponent, t as setClassOnTarget, e as setPotentialAttribute };